module.exports = __webpack_public_path__ + "img/9.096620d9.png";